import React from "react";
import { Link, useLocation } from "react-router-dom";
import { BookOpen, LogOut, Settings } from "lucide-react";
import { logout } from "@/lib/auth";

export default function Header({ right = null }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <header
      className="relative z-10 w-full max-w-6xl mx-auto flex items-center justify-between px-4 md:px-2 pt-8 md:pt-10"
      data-testid="app-header"
    >
      <Link
        to="/"
        className="flex items-center gap-3 group"
        data-testid="logo-link"
      >
        <div className="h-9 w-9 rounded-full bg-[#2e4733] flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
          <BookOpen size={16} className="text-[#f5f6f2]" strokeWidth={2.2} />
        </div>
        <div className="flex flex-col leading-tight">
          <span className="font-serif-fact text-[1.15rem] text-[#1c2723]">
            Liarthur
          </span>
          <span className="label-eyebrow text-[10px]">Tekrarla Öğren</span>
        </div>
      </Link>

      <div className="flex items-center gap-3">
        {right}
        <button
          type="button"
          onClick={logout}
          className="flex items-center gap-2 px-3 h-9 rounded-full text-[#5c635e] hover:text-[#1c2723] hover:bg-[#e8eae3] transition-colors text-sm"
        >
          <LogOut size={14} strokeWidth={2} />
          <span className="hidden sm:inline">Çıkış</span>
        </button>
        {!isAdmin && (
          <Link
            to="/admin"
            data-testid="admin-link"
            className="flex items-center gap-2 px-3 h-9 rounded-full text-[#5c635e] hover:text-[#1c2723] hover:bg-[#e8eae3] transition-colors text-sm"
          >
            <Settings size={14} strokeWidth={2} />
            <span className="hidden sm:inline">Yönetim</span>
          </Link>
        )}
      </div>
    </header>
  );
}
